import * as Constants from "../utils/constants";
import * as ApiUtils from "./api-utils";
import { TrainMode } from "./api-data-model";

export type MapTrainSection = {
  [year: string]: {
    f5min: number;
    f10min: number;
    f15min: number;
    f20min: number;
    f25min: number;
    f30min: number;
    f60min: number;
    f120min: number;
    alat: number;
    alon: number;
    aname: string;
    dlat: number;
    dlon: number;
    dname: string;
  }[];
};

export async function getTrainModeFilters(): Promise<TrainMode[]> {
  let response = await fetch(Constants.API_EP_MAP);
  let objResponse = await response.json();
  return objResponse.modes;
}

export async function getTrainSectionsByMode(
  modeId: string,
  ungrouped: boolean = false
): Promise<MapTrainSection[]> {
  let grouped = ungrouped ? "false" : "true";
  let url = ApiUtils.AppendParams(Constants.API_EP_MAP + modeId, { grouped });
  let response = await fetch(url);
  let geolocResp = await response.json();
  let sections = geolocResp.geolocation;
  return sections;
}
